import React from "react";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader";
import PageHeader from "../../../../components/PageHeader";
import Pagination from "../../../../components/Pagination";
import vi from "date-fns/locale/vi";
import {registerLocale} from "react-datepicker";
import {GRADE_CONST} from "../../../../components/Grade";
import DiscountAdmissionsSpecialController
    from "../../../../services/system/discount-admissions-special/discount-admissions-special-controller";
import ModalEditFeeItem from "./modalEditFeeItem";
import ModalCreateFeeItem from "./modalCreateFeeItem";
import FeeItemController from "../../../../services/system/fee-item/fee-item-controller";
import {getSchoolYear} from "../../../../utils/authority";
import Utils from "../../../../utils/utils";
registerLocale("vi", vi);
class FeeItemManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            state: "",
            listData: [],

            pageNumber: 0,
            pageSize: 20,
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "title",
                    name: "Tên",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "pos",
                    name: "Giá theo tháng",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "group",
                    name: "Giá theo kỳ",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "discount",
                    name: "Giá theo năm",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "note",
                    name: "Chú thích",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "state",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        this.getListPrice()
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListPrice();
            }
        );
    };
    getListPrice() {
        let payload = {
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            state: this.state.state,
            sort: "created_at desc",
            yearId: parseInt(getSchoolYear()),
        };
        FeeItemController.list(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Hoạt động"
            },
            {
                "id": "LOCK",
                "name": "Khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    getGrade(grade){
        return GRADE_CONST[grade];
    }

    render() {
        let {listData, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="fee-item" parentClass="wallet-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Cấu hình các khoản phí"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <button
                                                    style={{height: 35, marginRight: 12}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => {
                                                        this.setState({showModalCreate: true})
                                                    }}
                                                >
                                                    Thêm mới
                                                </button>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "left"
                                                 }}>
                                                <label className="label-item col-12"><b>Lưu ý:</b> Cấu hình các khoản phí đã được áp dụng thì không xóa được</label>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                    clickSort={data => {
                                                    }}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.name}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {Utils.formatMoney(row.priceMonth)} VNĐ
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.priceSemester)} VNĐ
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.priceYear)} VNĐ
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.note}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.state=="INACTIVE" ? <span className="badge badge-danger" style={{color: "white"}}>Khóa</span> : <span className="badge badge-success" style={{color: "white"}}>Hoạt động</span>}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                <button
                                                                    style={{cursor: 'pointer'}}
                                                                    title='Sửa'
                                                                    className="btn btn-action p-2"
                                                                    onClick={() => {
                                                                        this.setState({itemSelected: row.id, showModalEdit: true})
                                                                    }}
                                                                >
                                                                    <i className="ti-pencil-alt"/>
                                                                </button>
                                                                <button className="btn btn-action p-2"
                                                                        title='Xóa'
                                                                        style={{cursor: 'pointer'}}
                                                                        onClick={() => {
                                                                            this.setState({itemSelected: row.id, showModalDelete: true})
                                                                        }}
                                                                >
                                                                    <i className="ti-trash"/>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalEditFeeItem
                    show={this.state.showModalEdit}
                    onHide={() => this.setState({showModalEdit: false})}
                    onRefresh={() => this.getListPrice()}
                    id={this.state.itemSelected}
                />
                <ModalCreateFeeItem
                    show={this.state.showModalCreate}
                    onHide={() => this.setState({showModalCreate: false})}
                    onRefresh={() => this.getListPrice()}
                />
            </div>
        );
    }
}

export default FeeItemManagement;
